// test2969
(2969 && 0);
